import validate from 'validate.js'
import { getGlobal } from '../global/useGlobal'
import { cpf } from 'cpf-cnpj-validator'

validate.validators.equalityToCurrentPassword = (value: string, options: { message: string }) => {
  if (value !== getGlobal().currentPassword) {
    return options.message
  } else {
    return
  }
}

validate.validators.sequentialPassword = (value: string, options: { message: string }) => {
  const ascendingSequentialDigits = '0123456789'
  const descendingSequentialDigits = '9876543210'

  if (value) {
    if ((options && ascendingSequentialDigits.includes(value)) || descendingSequentialDigits.includes(value)) {
      return options.message
    }
  } else {
    return
  }
}

export const buildValidatorFromConstraints = (constraints: any) => (values: any) => {
  return validate(values, constraints)
}

export const buildValidatorFromConstraintsV2 = (constraints: any) => (values: any) => {
  const errors = validate(values, constraints)

  return {
    values: errors ? {} : values,
    errors: errors || {},
  }
}

validate.validators.cpf = (value: string, options: { message: string }) => {
  if (value) {
    if (options && !cpf.isValid(value, null)) {
      return options.message
    }
  } else {
    return
  }
}
